import { styled } from '@vebox/etui-system';
import { Div } from '@vebox/etui-system-elements';

const TableBodyDiv = styled(Div)`
  display: grid;
  position: absolute;
  top: 0px;
  width: 100%;
  grid-template-columns: ${props => props.columns.map(({
  width
}) => `${width ? typeof width === 'string' ? width : `${width}fr` : '1fr'} `)};
`;

export { TableBodyDiv as T };
